import { combineReducers } from 'redux';
import Auth from './auth/reducers';
import Loan from './loan/reducers';
import Property from './property/reducers';
import Security from './security/reducers';
import Lenders from './lender/reducers';
import calendarReducer from './calendar_ICS/reducers';
import UserManagement from './userManagement/reducers';
import notifications from './notifications/reducers';
import dispatchAdminUpdate from './AdminUpdatePushButton/reducers';
import reports from './reports/reducers';
import hubspotAPI from './hubspot_API/reducers';


export default combineReducers({
    Auth,
    Loan,
    Property,
    Lenders,
    Security,
    //Calendar
    calendarReducer,
    //User Management
    UserManagement,
    //Notifications
    notifications,
    //Admin Update Push Button
    dispatchAdminUpdate,
    //Reports Dashboard
    reports,
    hubspotAPI,

});

//All redux reducer functions need to be added to this page to be imported into the respective class 
// and define the state of the const 
// called in the store.js
